import Link from "next/link";
import React from "react";

type TExternalLink = {
  href: string;
  icon: React.ReactNode;
  label: string;
};

const ExternalLink = ({ href, icon, label }: TExternalLink) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 transition-all duration-200 rounded-[5px] py-1 text-sm hover:text-primary"
    >
      {icon}
      <span>{label}</span>
    </Link>
  );
};

export default ExternalLink;
